import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import VolunteerForm from "@/components/sections/VolunteerForm";

export default function VolunteerPage() {
  return (
    <div data-testid="volunteer-page" className="min-h-screen bg-[var(--bone)] text-[var(--ink)]">
      <Nav />
      <section className="pt-32 pb-8 md:pt-40 bg-[var(--bone)]">
        <div className="container-x">
          <div className="overline text-[var(--terracotta)]">Volunteer</div>
          <h1 className="font-serif text-5xl md:text-7xl mt-4 tracking-[-0.025em] leading-[0.95] max-w-5xl">
            Bring what you have. <em className="text-[var(--terracotta)] not-italic">We&apos;ll find a place for it.</em>
          </h1>
          <p className="text-[var(--ink)]/75 mt-8 max-w-2xl leading-relaxed text-lg">
            Engineers, teachers, doctors, photographers, plumbers, retired carpenters,
            second-year students — every single one of you matters to this work. Tell us
            a little about yourself below and we&apos;ll match you to a project.
          </p>
        </div>
      </section>
      <VolunteerForm />
      <Footer />
    </div>
  );
}
